// extracted by mini-css-extract-plugin
export default {"Box":"table-group-separator-module__Box--x6wQG"};